import React from 'react';
import { Facet } from '@elastic/react-search-ui';
import MultiCheckboxFacet from "../MultiCheckboxFacet/MultiCheckboxFacet";
import { useTranslation } from "react-i18next";
import BundleCategoryMultiCheckboxFacet from './BundleCategoryMultiCheckboxFacet';

const FileFacet = () => {
  const { t } = useTranslation();
  return (
    <div className="l-localnav j-nav">
      <h2 className="c-title--main border">{t("Filter by information")}</h2>
      <ul className="l-localnav__list level--0 u-form-label">
        <li>
          <div className="parent is-open">
            <button>{t("File Format")}</button>
          </div>
          <ul className="l-localnav__list level--1">
            <li>
              <Facet
                field="file_format"
                label={""}
                show={1000}
                view={props => (
                  <MultiCheckboxFacet
                    {...props}
                    fieldName="file_format"
                  />
                )}
              />
            </li>
          </ul>

        </li>

        <li>
          <div className="parent is-open">
            <button>{t("Bundle Category")}</button>
          </div>
          <ul className="l-localnav__list level--1">
            <li>
              <Facet
                field="bundle_category"
                label={""}
                show={1000}
                view={props => (
                  <BundleCategoryMultiCheckboxFacet
                    {...props}
                    fieldName="bundle_category"
                  />
                )}
              />
            </li>
          </ul>

        </li>
      </ul>

    </div>
  );
};

export default FileFacet;